import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-ui-header-icon',
  templateUrl: 'header-icon.component.html',
  styleUrls: ['./header-icon.component.scss'],
  imports: [
    MatTooltip,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderIconComponent {
  public icon = input.required<IconsEnum>();
  public isClickable = input<boolean>(true);
  public isDisabled = input<boolean>(false);
  public tooltip = input<string | undefined>(undefined);

  constructor() {
  }
}
